import { useParams } from "react-router";
import Retool from ".";

const MainDashboard = () => {
  const reportID = "b935ea10-5024-11f0-b6b0-a3a76adb57be";
  const { id: BuildingId } = useParams();

  const embeddedData = {
    building_id: BuildingId,
  };

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default MainDashboard;
